<template>
    <label :for="inputId">
        <CardSelectableItem
            :autoFocus
            :error
            :formControlPosition
            :helperText
            :label
            :selected="!!model"
        >
            <template #formControl>
                <DsCheckbox
                    v-model="model"
                    :inputId
                    :name
                    noLabelWrapper
                    :value
                />
            </template>
            <slot v-if="$slots.default" />
        </CardSelectableItem>
    </label>
</template>

<script setup lang="ts">
import { useId } from 'vue';
import CardSelectableItem from './CardSelectableItem.vue';
import DsCheckbox from './DsCheckbox.vue';

export interface DsCardCheckboxProps {
    label?: string;
    helperText?: string;
    name: HTMLInputElement['name'];
    value: HTMLInputElement['value'];
    error?: string | boolean;
    autoFocus?: boolean;
    formControlPosition?: 'left' | 'right';
    inputId?: HTMLInputElement['id'];
}

const props = withDefaults(defineProps<DsCardCheckboxProps>(), {
    error: false,
    autoFocus: false,
    formControlPosition: 'left',
});

const inputId = props.inputId ?? useId();

const model = defineModel();

defineSlots<{
    default: () => void;
}>();
</script>
